import styled, { css } from 'styled-components';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{
	$fullWidth?: boolean;
	$onlyCount?: boolean;
}>`
	display: grid;
	grid-template-columns: ${(props) =>
		props.$onlyCount ? 'auto auto' : '1fr auto'};
	align-items: center;
	gap: 20px;

	${(props) =>
		props.$fullWidth &&
		css`
			width: 100%;
		`}

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledNameContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	justify-content: flex-start;
`;

const StyledVariant = styled(Text)`
	opacity: 0.5;
	flex-shrink: 0;
`;

const StyledName = styled(Text)`
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	flex-shrink: 1;
`;

const StyledRightContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledArrow = styled.div`
	width: 10px;
	height: 10px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${arrowLeft});
	mask-size: 10px 10px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${arrowLeft});
	-webkit-mask-size: 10px 10px;
	background-color: #ffffff;
	transition:
		background-color 0.3s ease,
		opacity 0.3s ease;
`;

const StyledButtonContainer = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 20px;
	cursor: pointer;
	transition: background-color 0.3s ease;
	will-change: background-color;

	${(props) =>
		props.$disabled
			? css`
					background-color: rgba(255, 255, 255, 0.05);

					${StyledArrow} {
						opacity: 0.25;
					}
			  `
			: css`
					background-color: rgba(255, 255, 255, 0.1);

					&:hover {
						background-color: #ffffff;

						${StyledArrow} {
							background-color: #000000;
						}
					}
			  `}
`;

export {
	StyledArrow,
	StyledButtonContainer,
	StyledContainer,
	StyledName,
	StyledNameContainer,
	StyledRightContainer,
	StyledVariant,
};
